import { render, staticRenderFns } from "./cfluckydrawrecord.vue?vue&type=template&id=0ac9d603"
import script from "./cfluckydrawrecord.vue?vue&type=script&lang=js"
export * from "./cfluckydrawrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports